// getters
const papeleriaDeliveries = state => state.papeleriaDeliveries

export default {
  papeleriaDeliveries
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/deliveries/getters.js